import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  styled,
  TableBody,
  TableCell,
  Avatar,
  Box,
  Skeleton,
  Checkbox,
} from "@mui/material";
import React, { useCallback, useState } from "react";
import styles from "./Nurture.module.css";
import { tableCellClasses } from "@mui/material/TableCell";
import { useAuthUser } from "react-auth-kit";
import LeadCardDropdown from "./LeadCardDropdown/LeadCardDropdown";
import noFilteredLeadsImg from "../components/Assets/noLeadsImg.svg";
import {
  checkSubDomainAccess,
  getSubDomainAccessStatus,
} from "../../../../components/RolePermissionAccess/RolePermissionAccess";
import {
  updateEnquiryProfileTag,
  updateLeadAssignee,
  updateLeadPriority,
  updateLeadSwimlaneStatus,
} from "../service/nurtureSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";
import getTeamMember, {
  getDescriptionWithMentionedNames,
} from "../../../../components/CommonFunctions/CommonFunctions";
import { TableComponents, TableVirtuoso } from "react-virtuoso";
import moment from "moment";
import PillDropdown from "../../../../components/PillsDropdown/PillsDropdown";
import openDrawerIcon from "../../../../assets/images/openDrawerNotes.svg";
import NotesTaskDrawer from "./NotesTaskDrawer";
import PaymentPopupFromConversion from "./PaymentPopupFromConversion";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { openLeadExpandModal } from "../../../../components/LeadPopup/hooks/useLeadCard";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F5F5F5",
    color: "#667085",
    borderBottom: "10px solid #f5f5f5",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderBottom: "5px solid #f5f5f5",
  },
}));

const nurtureList = [
  {
    name: "Olivia Rhye",
    id: "l1",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l2",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l3",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l4",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l5",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
  {
    name: "Olivia Rhye",
    id: "l6",
    email: "oliviarhye@gmail.com",
    phoneNumber: 85459575855,
    stage: "New Enquiry",
    assignee: "Davidson",
    priority: "Urgent",
    source: "WhatsApp",
  },
];

const NurtureList = (props: any) => {
  const {
    handleDragStart,
    hasMoreData,
    setHasMoreData,
    GetLeadNoteList,
    CreateTask,
    CreateNote,
    EditTask,
    DeleteTask,
    UpdateTaskStatus,
    leadTaskList,
    employees,
    taskTypes,
    EditNote,
    DeleteNote,
    leadNoteList,
    leadItems,
    GetLeadTaskList,

    lead,

    UpdateLeadPriority,
    setValue,
    setExpandedLead,
    setLeadSearchTerm,
    leadSearchTerm,
    filterCheckedBranches,
    filterCheckedBatches,
    filterCheckedPriorities,
    filterCheckedSources,
    filterCheckedAssignees,
    selectedCourse,
    courseLeadCount,
    UpdateLeadSwimlaneStatus,
    UpdateLeadEnquiyStatus,
    filterCheckedStages,
    leadPaginationLoad,
    paginatedLeadId,
    setPaginatedLeadId,
    lastEvaluatedKey,
    leadListItems,
    allLeadsEmpty,
    nurtureLeadStatus,
    filterApplied,
    selectedCourseForMoving,
    setSelectedCourseForMoving,
    isCheckboxChecked,
    setIsCheckboxChecked,
    selectedContacts,
    setSelectedContacts,
    leadStatusUpdateSuccess,
    setLeadListItems,
    defaultLeadsCall,
    sortingOrder,
    setSortingOrder,
    sortingLeadsCall,
    sortingOrderForLastActivity,
    setSortingOrderForLastActivity,
    defaultIconForLast,
    setDefaultIconForLast,
    defaultIcon,
    setDefaultIcon,
  } = props;

  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();

  const { userById } = useSelector((state: any) => state.userDetails);
  const [openDrawerModal, setDrawerModal] = useState<boolean>(false);
  const [itemForNotesTask, setItemForNotesTask] = useState<any>();
  const [openConversionPaymentPopup, setOpenConversionPaymentPopup] =
    useState(false);

  const hasLeadAccess = getSubDomainAccessStatus(
    "NURTURE_BOARD",
    "LEAD_CARD",
    "ALL_ACCESS",
    userById?.rolePermission
  );

  const hasLeadCardPermission = checkSubDomainAccess(
    "NURTURE_BOARD",
    "LEAD_CARD",
    userById?.rolePermission
  );
  const { onLeadsLoading, onLeadsData } = useSelector(
    (state: any) => state.nurture
  );

  const [openRows, setOpenRows] = useState(
    Array(nurtureList.length).fill(false)
  );
  const [activeTab, setActiveTab] = useState<number>(0);

  const handleRowToggle = (index: number) => {
    const newOpenRows = Array(nurtureList.length).fill(false);
    newOpenRows[index] = !openRows[index];
    setOpenRows(newOpenRows);
  };

  const handleLeadPriority = React.useCallback(
    (leadId: any, leadPriority: any) => {
      if (leadPriority !== undefined) {
        if (leadId && leadPriority) {
          dispatch<any>(
            updateLeadPriority({
              enquiryId: leadId,
              enquiryPriority:
                leadPriority?.label === "Urgent"
                  ? "URGENT"
                  : leadPriority?.label === "High"
                  ? "HIGH"
                  : leadPriority?.label === "Normal"
                  ? "NORMAL"
                  : "LOW",
              updatedByName: authUser?.firstName + " " + authUser?.lastName,
              updatedById: authUser?.institute[0]?.id,
              instituteId: authUser?.institute[0]?.instituteId,
            })
          );
        }
      }
    },
    [updateLeadPriority]
  );

  const filteredLeads =
    leadListItems &&
    leadListItems?.filter((data: any) => {
      if (selectedCourse === null) {
        return true;
      }
      return data.courseId === selectedCourse.courseId;
    });

  React.useEffect(() => {
    if (paginatedLeadId) {
      const element = document.getElementById(paginatedLeadId);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "start",
        });
      }

      const timeoutId = setTimeout(() => {
        setPaginatedLeadId("");
      }, 2000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [leadListItems]);

  React.useEffect(() => {
    if (onLeadsLoading === true) {
      setExpandedLead(null);
      setOpenRows(Array(nurtureList.length).fill(false));
    }
  }, [onLeadsLoading]);

  interface CustomTableComponents extends TableComponents<any> {
    Table: React.FC<any>;
    TableHead: typeof TableHead;
    TableRow: React.FC<any>;
    TableBody: React.ForwardRefExoticComponent<any>;
  }
  const VirtuosoTableComponents: CustomTableComponents = {
    // Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (
    // <TableContainer
    // // component={Paper}
    // {...props}
    // ref={ref}
    // className={styles.listTableContainer}
    // />
    // )),
    Table: (props) => (
      <Table {...props} style={{ borderCollapse: "separate" }} />
    ),
    TableHead: (props: any) => (
      <TableHead {...props} className={styles.batchPopupHead} />
    ),
    TableRow: ({ item, ...props }) => {
      return (
        <>
          <TableRow
            draggable
            onDragStart={(event: any) =>
              handleDragStart(event, "contacted", item.id, item)
            }
            id={item?.id}
            sx={{
              borderRadius: "2px",
              backgroundColor: item?.status === "LOST" ? "#F4EDED" : "#FFFFFF",
              border:
                item?.status === "LOST"
                  ? "1px solid #F1B3B3"
                  : "1px solid #F0F0F0",
              margin: "10px 0 !important",
            }}
            {...props}
          />
        </>
      );
    },
    TableBody: React.forwardRef<HTMLTableSectionElement>((props, ref) =>
      leadSearchTerm === "" &&
      leadListItems?.length === 0 &&
      filterApplied === true &&
      courseLeadCount !== 0 &&
      onLeadsData !== null ? (
        <TableBody {...props} ref={ref}>
          <div
            style={{
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "999",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                style={{ width: "56px", marginBottom: "10px" }}
                src={noFilteredLeadsImg}
                alt="noFilteredLeadsImg"
              />
              <div
                style={{
                  color: "#667085",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "8px",
                  textTransform: "capitalize",
                  textAlign: "center",
                }}
              >
                No data available
              </div>
              <div
                style={{
                  color: "#667085",
                  fontSize: "13px",
                  fontWeight: "500",
                  textAlign: "center",
                }}
              >
                Try applying a different filter
              </div>
            </div>
          </div>
        </TableBody>
      ) : (
        <TableBody {...props} ref={ref} />
      )
    ),
  };

  const handleCheckboxToggle = (contactId: string) => {
    setSelectedContacts((prevSelectedContacts: any) => {
      if (prevSelectedContacts.includes(contactId)) {
        const updatedContacts = prevSelectedContacts.filter(
          (id: any) => id !== contactId
        );
        setIsCheckboxChecked(updatedContacts.length > 0);
        return updatedContacts;
      } else {
        setIsCheckboxChecked(true);
        return [...prevSelectedContacts, contactId];
      }
    });
  };

  const handleCourseToggle = (row: any) => {
    setSelectedCourseForMoving((prevSelectedCourse: any) => {
      if (prevSelectedCourse.includes(row)) {
        const updatedCourses = prevSelectedCourse?.filter(
          (ds: any) => ds?.id !== row?.id
        );
        setIsCheckboxChecked(updatedCourses.length > 0);
        return updatedCourses;
      } else {
        setIsCheckboxChecked(true);
        return [...prevSelectedCourse, row];
      }
    });
  };

  const handleLeadAssignee = useCallback(
    (leadId: any, user: any) => {
      if (user !== undefined) {
        if (leadId && user) {
          dispatch<any>(
            updateLeadAssignee({
              enquiryId: leadId,
              teamMemberId: user.value,
              teamMemberName: user.label,
              updatedByName: authUser?.firstName + " " + authUser?.lastName,
              updatedById: authUser?.institute[0]?.id,
              instituteId: authUser?.institute[0]?.instituteId,
            })
          );
        }
      }
    },
    [updateLeadAssignee, authUser]
  );

  const loginUserBranch = authUser?.institute?.[0]?.branchId;

  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );

  const filteredUsers =
    employees &&
    employees
      ?.filter((user: any) => {
        return user.status === "ACTIVE" && user?.leadCardAccess === true;
      })
      ?.filter((item: any) =>
        !hasAllBranchAccess ? item.branchId === loginUserBranch : true
      );

  const handleUpdatingSwimlaneStatus = useCallback(
    (leadId: any, info: any) => {
      if (info !== undefined) {
        dispatch<any>(
          updateLeadSwimlaneStatus({
            enquiryId: leadId,
            swimlaneStatus:
              info?.label === "New Enquiry"
                ? "NEW_ENQUIRY"
                : info?.label === "Demo"
                ? "DEMO"
                : info?.label === "Contacted"
                ? "CONTACTED"
                : info?.label === "Negotiation"
                ? "NEGOTIATION"
                : "CONVERTED",
            updatedByName: authUser?.firstName + " " + authUser?.lastName,
            updatedById: authUser?.institute[0]?.id,
            instituteId: authUser?.institute[0]?.instituteId,
          })
        );
      }
    },
    [updateLeadSwimlaneStatus]
  );

  const handleUpdatingEnquiryProfileTag = useCallback(
    (leadId: any, info: any) => {
      if (info !== undefined) {
        dispatch<any>(
          updateEnquiryProfileTag({
            updatedByName: authUser?.firstName + " " + authUser?.lastName,
            updatedById: authUser?.institute[0]?.id,
            enquiryProfileTag:
              info?.label === "Select"
                ? "SELECT"
                : info?.label === "Cold"
                ? "COLD"
                : info?.label === "Warm"
                ? "WARM"
                : info?.label === "Hot"
                ? "HOT"
                : info?.label === "Interested"
                ? "INTERESTED"
                : info?.label === "Followup"
                ? "FOLLOWUP"
                : info?.label === "Invalid"
                ? "INVALID"
                : info?.label === "Disqualified"
                ? "DISQUALIFIED"
                : info?.label === "Not Answering"
                ? "NOT_ANSWERING"
                : info?.label === "Not Interested"
                ? "NOT_INTERESTED"
                : info?.label === "Future Prospect"
                ? "FUTURE_PROSPECT"
                : info?.label === "Budget Constraint"
                ? "BUDGET_CONSTRAINT"
                : info?.label === "Not Reachable"
                ? "NOT_REACHABLE"
                : info?.label === "Lost"
                ? "LOST"
                : info?.label === "Shortlisted"
                ? "SHORTLISTED"
                : info?.label === "Admission"
                ? "ADMISSION"
                : info?.label === "Exam Schedule"
                ? "EXAM_SCHEDULE"
                : info?.label === "Qualified"
                ? "QUALIFIED"
                : info?.label === "Placement Done"
                ? "PLACEMENT_DONE"
                : info?.label === "Flexi Payment Plan"
                ? "FLEXI_PAYMENT_PLAN"
                : info?.label === "Call Back"
                ? "CALL_BACK"
                : "",
            enquiryId: leadId,
          })
        );
      }
    },
    [updateEnquiryProfileTag]
  );

  React.useEffect(() => {
    if (leadStatusUpdateSuccess === "Please record a payment to continue.") {
      setOpenConversionPaymentPopup(true);
    }
  }, [leadStatusUpdateSuccess]);

  const handleAscending = (value: string) => {
    sortingLeadsCall(
      true,
      nurtureLeadStatus,
      selectedCourse?.courseId,
      value,
      "asc"
    );

    setSortingOrder("asc");
    setSortingOrderForLastActivity("desc");

    const queryParams = new URLSearchParams(window.location.search);
    setDefaultIcon(false);
    setDefaultIconForLast(true);

    setDefaultIconForLast(false);
    setDefaultIcon(true);
    queryParams.set("sortingOrder", "asc");
    queryParams.set("sortingKey", value);
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${
      queryString ? `?${queryString}` : ""
    }`;
    window.history.pushState({}, "", newUrl);
  };

  const handleAscendingLastActivity = (value: string) => {
    sortingLeadsCall(
      true,
      nurtureLeadStatus,
      selectedCourse?.courseId,
      value,
      "asc"
    );

    setSortingOrderForLastActivity("asc");
    setSortingOrder("desc");

    const queryParams = new URLSearchParams(window.location.search);

    setDefaultIconForLast(false);
    setDefaultIcon(true);
    queryParams.set("sortingOrder", "asc");
    queryParams.set("sortingKey", value);
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${
      queryString ? `?${queryString}` : ""
    }`;
    window.history.pushState({}, "", newUrl);
  };

  const handleDescending = (value: string) => {
    sortingLeadsCall(
      true,
      nurtureLeadStatus,
      selectedCourse?.courseId,
      value,
      "desc"
    );

    setSortingOrder("desc");
    setSortingOrderForLastActivity("desc");

    const queryParams = new URLSearchParams(window.location.search);

    setDefaultIcon(false);

    queryParams.set("sortingOrder", "desc");
    queryParams.set("sortingKey", value);
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${
      queryString ? `?${queryString}` : ""
    }`;
    window.history.pushState({}, "", newUrl);
  };

  const handleDescendingLastActivity = (value: string) => {
    sortingLeadsCall(
      true,
      nurtureLeadStatus,
      selectedCourse?.courseId,
      value,
      "desc"
    );
    setSortingOrder("desc");

    setSortingOrderForLastActivity("desc");
    const queryParams = new URLSearchParams(window.location.search);

    setDefaultIconForLast(false);
    setDefaultIcon(true);
    queryParams.set("sortingOrder", "desc");
    queryParams.set("sortingKey", value);
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${
      queryString ? `?${queryString}` : ""
    }`;
    window.history.pushState({}, "", newUrl);
  };

  const { leadUpdateNotify } = useSelector(
    (state: any) => state?.websocketNotifications
  );

  return (
    <div style={{ overflow: "auto", height: "100%" }}>
      {leadListItems && onLeadsData !== null ? (
        <>
          <TableVirtuoso
            style={{
              height: "calc(100vh - 180px)",
              background: "#f5f5f5",
            }}
            totalCount={filteredLeads?.length || 0}
            components={VirtuosoTableComponents}
            data={filteredLeads || []}
            fixedHeaderContent={() => (
              <TableRow>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  sx={{ borderBottom: "none", width: "5%", maxWidth: "5%" }}
                >
                  <Checkbox
                    sx={{
                      strokeWidth: 1,
                      color: "rgba(102, 112, 133, 0.30)",
                    }}
                    checked={
                      filteredLeads?.length > 0 &&
                      selectedContacts?.length === filteredLeads?.length
                    }
                    onChange={() => {
                      if (selectedContacts?.length === filteredLeads?.length) {
                        setIsCheckboxChecked(false);
                        setSelectedContacts([]);

                        setSelectedCourseForMoving([]);
                      } else {
                        const allEmailIds = filteredLeads?.map(
                          (item: any) => item.id
                        );
                        const allContacts = filteredLeads?.map(
                          (item: any) => item
                        );
                        setSelectedContacts(allEmailIds);

                        setIsCheckboxChecked(true);
                        setSelectedCourseForMoving(allContacts);
                      }
                    }}
                  />
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  sx={{
                    borderBottom: "none",
                    width: "26%",
                    maxWidth: "26%",
                  }}
                >
                  Name
                </StyledTableCell>

                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="left"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Phone Number
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{
                    borderBottom: "none",
                    width: "12%",
                    maxWidth: "12%",
                  }}
                >
                  Tag
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Stage
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Assignee
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {"Assigned On"}
                    {defaultIcon ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "-10",
                        }}
                      >
                        <KeyboardArrowDownIcon
                          onClick={() => handleAscending("lastAssignedOnDate")}
                          sx={{ fontSize: "20px", cursor: "pointer" }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "-10",
                        }}
                      >
                        {sortingOrder === "asc" ? (
                          <ArrowDropUpIcon
                            onClick={() =>
                              handleDescending("lastAssignedOnDate")
                            }
                            sx={{ fontSize: "20px", cursor: "pointer" }}
                          />
                        ) : (
                          <ArrowDropDownIcon
                            onClick={() =>
                              handleAscending("lastAssignedOnDate")
                            }
                            sx={{ fontSize: "20px", cursor: "pointer" }}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="left"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Last Note
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="center"
                  sx={{ borderBottom: "none", width: "10%", maxWidth: "10%" }}
                >
                  Priority
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="left"
                  sx={{
                    borderBottom: "none",
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {"Last Activity Time"}
                    {defaultIconForLast ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "-10",
                        }}
                      >
                        <KeyboardArrowDownIcon
                          onClick={() =>
                            handleAscendingLastActivity("lastActivityDate")
                          }
                          sx={{ fontSize: "20px", cursor: "pointer" }}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "-10",
                        }}
                      >
                        {sortingOrderForLastActivity === "asc" ? (
                          <ArrowDropUpIcon
                            onClick={() =>
                              handleDescendingLastActivity("lastActivityDate")
                            }
                            sx={{ fontSize: "20px", cursor: "pointer" }}
                          />
                        ) : (
                          <ArrowDropDownIcon
                            onClick={() =>
                              handleAscendingLastActivity("lastActivityDate")
                            }
                            sx={{ fontSize: "20px", cursor: "pointer" }}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  align="left"
                  style={{
                    minWidth: "250px",
                    maxWidth: "400px",
                  }}
                >
                  Source
                </StyledTableCell>
                <StyledTableCell
                  className={styles.batchPopupHeadCell}
                  sx={{
                    borderBottom: "none",
                    textAlign: "center",
                    width: "5%",
                    maxWidth: "5%",
                  }}
                >
                  {filteredLeads?.length}
                </StyledTableCell>
              </TableRow>
            )}
            itemContent={(index: number, item: any) => {
              return (
                <React.Fragment key={item?.id || index}>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      textTransform: "capitalize",
                      borderBottom: "none",
                      width: "5%",
                      maxWidth: "5%",
                    }}
                  >
                    <Checkbox
                      sx={{
                        strokeWidth: 1,
                        color: "rgba(102, 112, 133, 0.30)",
                      }}
                      checked={selectedContacts?.includes(item?.id)}
                      onChange={() => {
                        handleCheckboxToggle(item.id);
                        handleCourseToggle(item);
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "26%",
                      maxWidth: "26%",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <div className={styles.agentCardImg}>
                          <Avatar
                            alt="avatar"
                            sx={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "50%",
                              fontSize: "17px",
                              background: "#F5F5F7",
                              border: "1px solid #EEEEF4",
                              color: "#667085",
                            }}
                          >
                            {item?.studentFirstName?.charAt(0)}
                          </Avatar>
                        </div>
                        <div>
                          <Box
                            sx={{
                              textTransform: "capitalize",
                              cursor: "pointer",
                              ":hover": {
                                color: "#11c89b",
                                transition: "0.3s",
                              },
                            }}
                            onClick={() => {
                              if (selectedCourseForMoving?.length === 0) {
                                hasLeadCardPermission
                                  ? openLeadExpandModal(
                                      item?.instituteId,
                                      item?.studentContact,
                                      item?.studentEmail,
                                      item?.id,
                                      dispatch,
                                      ""
                                    )
                                  : dispatch(
                                      setToastNotification({
                                        message:
                                          "You do not have permission to access the lead card",
                                        type: "error",
                                        snackOpen: true,
                                      })
                                    );
                              }
                            }}
                          >
                            {`${item?.studentFirstName} ${item?.studentLastName}`}
                          </Box>
                          <div>{item?.studentEmail}</div>
                        </div>
                      </div>
                      {selectedCourseForMoving?.length === 0 && (
                        <div
                          onClick={() => {
                            GetLeadTaskList(item.id);
                            GetLeadNoteList(item.id);
                            setDrawerModal(true);
                            setItemForNotesTask(item);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <img src={openDrawerIcon} />
                        </div>
                      )}
                    </div>
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "12%",
                      maxWidth: "12%",
                    }}
                  >
                    {item?.studentContact
                      ? `+${item?.contactCountryCode || "91"} ${
                          item?.contactCountryCode
                            ? item?.studentContact?.replace(
                                item?.contactCountryCode,
                                ""
                              )
                            : item?.studentContact?.startsWith("91")
                            ? item?.studentContact?.replace("91", "")
                            : item?.studentContact
                        }`
                      : "-"}
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "20%",
                      maxWidth: "20%",
                    }}
                  >
                    {item?.enquiryProfileTag ? (
                      <PillDropdown
                        value={
                          item?.enquiryProfileTag === "SELECT"
                            ? "Select"
                            : item?.enquiryProfileTag === "COLD"
                            ? "Cold"
                            : item?.enquiryProfileTag === "WARM"
                            ? "Warm"
                            : item?.enquiryProfileTag === "HOT"
                            ? "Hot"
                            : item?.enquiryProfileTag === "INTERESTED"
                            ? "Interested"
                            : item?.enquiryProfileTag === "FOLLOWUP"
                            ? "Followup"
                            : item?.enquiryProfileTag === "INVALID"
                            ? "Invalid"
                            : item?.enquiryProfileTag === "DISQUALIFIED"
                            ? "Disqualified"
                            : item?.enquiryProfileTag === "NOT_ANSWERING"
                            ? "Not Answering"
                            : item?.enquiryProfileTag === "NOT_INTERESTED"
                            ? "Not Interested"
                            : item?.enquiryProfileTag === "FUTURE_PROSPECT"
                            ? "Future Prospect"
                            : item?.enquiryProfileTag === "BUDGET_CONSTRAINT"
                            ? "Budget Constraint"
                            : item?.enquiryProfileTag === "NOT_REACHABLE"
                            ? "Not Reachable"
                            : item?.enquiryProfileTag === "LOST"
                            ? "Lost"
                            : item?.enquiryProfileTag === "SHORTLISTED"
                            ? "Shortlisted"
                            : item?.enquiryProfileTag === "ADMISSION"
                            ? "Admission"
                            : item?.enquiryProfileTag === "EXAM_SCHEDULE"
                            ? "Exam Schedule"
                            : item?.enquiryProfileTag === "QUALIFIED"
                            ? "Qualified"
                            : item?.enquiryProfileTag === "PLACEMENT_DONE"
                            ? "Placement Done"
                            : item?.enquiryProfileTag === "FLEXI_PAYMENT_PLAN"
                            ? "Flexi Payment Plan"
                            : item?.enquiryProfileTag === "CALL_BACK"
                            ? "Call Back"
                            : ""
                        }
                        options={[
                          { value: 0, label: "Select" },
                          { value: 1, label: "Cold" },
                          { value: 2, label: "Warm" },
                          { value: 3, label: "Hot" },
                          { value: 4, label: "Interested" },
                          { value: 5, label: "Followup" },
                          { value: 6, label: "Invalid" },
                          { value: 7, label: "Disqualified" },
                          { value: 8, label: "Not Answering" },
                          { value: 9, label: "Not Interested" },
                          { value: 10, label: "Future Prospect" },
                          { value: 11, label: "Budget Constraint" },
                          { value: 12, label: "Not Reachable" },
                          { value: 13, label: "Lost" },
                          { value: 14, label: "Shortlisted" },
                          { value: 15, label: "Admission" },
                          { value: 16, label: "Exam Schedule" },
                          { value: 17, label: "Qualified" },
                          { value: 18, label: "Placement Done" },
                          { value: 19, label: "Flexi Payment Plan" },
                          { value: 20, label: "Call Back" },
                        ]}
                        backgroundColor={"#f0edff"}
                        color={"#573de4"}
                        hoverBackgroundColor={"#e4ddff"}
                        handleSelect={handleUpdatingEnquiryProfileTag}
                        leadId={item?.id}
                        disabled={leadUpdateNotify === true}
                      />
                    ) : (
                      "-"
                    )}
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "20%",
                      maxWidth: "20%",
                    }}
                  >
                    <PillDropdown
                      value={item?.enquirySwimlaneStatus
                        ?.replace(/_/g, " ")
                        .toLowerCase()}
                      options={[
                        { value: 0, label: "New Enquiry" },
                        { value: 1, label: "Contacted" },
                        { value: 2, label: "Demo" },
                        { value: 3, label: "Negotiation" },
                        { value: 4, label: "Converted" },
                      ]}
                      backgroundColor={"rgba(219, 233, 253, 1)"}
                      color={"rgba(37, 68, 169, 1)"}
                      hoverBackgroundColor={"rgba(219, 233, 253, 0.8)"}
                      handleSelect={handleUpdatingSwimlaneStatus}
                      leadId={item?.id}
                      disabled={leadUpdateNotify === true}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "25%",
                      maxWidth: "25%",
                    }}
                  >
                    <PillDropdown
                      value={`${
                        getTeamMember(item?.assignedToId, employees)?.firstName
                      } ${
                        getTeamMember(item?.assignedToId, employees)?.lastName
                      }`}
                      options={
                        filteredUsers &&
                        filteredUsers?.map((d: any) => {
                          return {
                            value: d.id,
                            label: `${d?.firstName} ${d?.lastName}`,
                          };
                        })
                      }
                      backgroundColor={"#fff"}
                      color={"#667085"}
                      hoverBackgroundColor={"#fff"}
                      isEmployee={true}
                      handleSelect={handleLeadAssignee}
                      leadId={item?.id}
                      disabled={leadUpdateNotify === true}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "25%",
                      maxWidth: "25%",
                    }}
                  >
                    {moment(item?.lastAssignedOnDate).format(
                      "DD/MM/YYYY hh:mm A"
                    )}
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "20%",
                      maxWidth: "20%",
                    }}
                  >
                    <div
                      className={styles.activityDescription}
                      dangerouslySetInnerHTML={{
                        __html: item?.lastNote
                          ? item?.lastNote?.length <= 20
                            ? getDescriptionWithMentionedNames(
                                item?.lastNote,
                                filteredUsers
                              ).replace(/\n/g, "<br>")
                            : item?.lastNote?.length >= 20
                            ? `${getDescriptionWithMentionedNames(
                                item?.lastNote,
                                filteredUsers
                              )
                                .replace(/\n/g, "<br>")
                                ?.slice(0, 15)}...`
                            : "-"
                          : "-",
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "10%",
                      maxWidth: "10%",
                    }}
                  >
                    <PillDropdown
                      value={`${item?.enquiryPriority?.toLowerCase()}`}
                      options={[
                        { value: 0, label: "Urgent" },
                        { value: 1, label: "High" },
                        { value: 2, label: "Normal" },
                        { value: 3, label: "Low" },
                      ]}
                      backgroundColor={"rgba(242, 244, 247, 1)"}
                      color={"#667085"}
                      hoverBackgroundColor={"rgba(242, 244, 247, 0.8)"}
                      isPriority={true}
                      handleSelect={handleLeadPriority}
                      leadId={item?.id}
                      disabled={leadUpdateNotify === true}
                    />
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "30%",
                      maxWidth: "30%",
                    }}
                  >
                    {moment(item?.lastActivityDate).format(
                      "DD/MM/YYYY hh:mm A"
                    )}
                  </StyledTableCell>

                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      textTransform: "capitalize",
                      width: "15%",
                      minWidth: "15%",
                    }}
                  >
                    {item?.enquirySource?.replace(/_/g, " ").toLowerCase()}
                  </StyledTableCell>
                  <StyledTableCell
                    align="left"
                    sx={{
                      color: "#667085",
                      borderBottom: "none",
                      width: "5%",
                      maxWidth: "5%",
                    }}
                  >
                    {selectedCourseForMoving?.length === 0 ? (
                      <>
                        {hasLeadAccess &&
                          item?.enquirySwimlaneStatus !== "CONVERTED" && (
                            <LeadCardDropdown
                              UpdateLeadSwimlaneStatus={
                                UpdateLeadSwimlaneStatus
                              }
                              leadDetails={item}
                              UpdateLeadEnquiyStatus={UpdateLeadEnquiyStatus}
                              authUser={authUser}
                            />
                          )}
                      </>
                    ) : (
                      <></>
                    )}
                  </StyledTableCell>
                  {leadListItems &&
                    leadSearchTerm !== "" &&
                    courseLeadCount !== 0 &&
                    filteredLeads?.length === 0 && (
                      // <TableRow>
                      <TableCell colSpan={7} align="center">
                        No leads found with the specified search term.
                      </TableCell>
                      // </TableRow>
                    )}
                </React.Fragment>
              );
            }}
          />
        </>
      ) : (
        <div className={styles.kanbanColumn} style={{ marginBottom: "8px" }}>
          <div
            className={styles.kanbanColumnHead}
            style={{ gap: "60px", padding: "16px" }}
          >
            <Skeleton animation="wave" variant="text" width={115} height={25} />
            <Skeleton animation="wave" variant="text" width={210} height={25} />
            <Skeleton animation="wave" variant="text" width={115} height={25} />
            <Skeleton animation="wave" variant="text" width={155} height={25} />
            <Skeleton animation="wave" variant="text" width={112} height={25} />
            <Skeleton animation="wave" variant="text" width={115} height={25} />
          </div>
          {Array.from({ length: 8 }, (_, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#FFF",
                borderRadius: "2px",
                marginTop: "10px",
                height: "72px",
                padding: "16px",
                display: "flex",
                alignItems: "center",
                gap: "60px",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={30}
                  height={30}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={80}
                  height={25}
                />
              </div>

              <Skeleton
                animation="wave"
                variant="text"
                width={210}
                height={25}
              />
              <Skeleton
                animation="wave"
                variant="text"
                width={110}
                height={25}
              />
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={25}
                  height={25}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={125}
                  height={25}
                />
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "6px" }}
              >
                <Skeleton
                  animation="wave"
                  variant="circular"
                  width={25}
                  height={25}
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  width={85}
                  height={25}
                />
              </div>

              <Skeleton
                animation="wave"
                variant="text"
                width={110}
                height={25}
              />
              <Skeleton
                animation="wave"
                variant="text"
                width={15}
                height={25}
              />
            </div>
          ))}
        </div>
      )}
      {openDrawerModal && (
        <NotesTaskDrawer
          setDrawerModal={setDrawerModal}
          openDrawerModal={openDrawerModal}
          {...props}
          CreateTask={CreateTask}
          EditTask={EditTask}
          DeleteTask={DeleteTask}
          UpdateTaskStatus={UpdateTaskStatus}
          selectedLeadData={itemForNotesTask}
          leadTaskList={leadTaskList}
          employees={employees}
          taskTypes={taskTypes}
          CreateNote={CreateNote}
          EditNote={EditNote}
          DeleteNote={DeleteNote}
          leadNoteList={leadNoteList}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          GetLeadTaskList={GetLeadTaskList}
          GetLeadNoteList={GetLeadNoteList}
        />
      )}
      {openConversionPaymentPopup && (
        <PaymentPopupFromConversion
          openConversionPaymentPopup={openConversionPaymentPopup}
          setOpenConversionPaymentPopup={setOpenConversionPaymentPopup}
        />
      )}
    </div>
  );
};

export default NurtureList;
